import React from "react";
import Loading from "../scss/Video/Loading.gif";

const LoadingAbout = () => {
  return (
    <div
      style={{
        backgroundColor: "black",
        width: "100%",
        height: "100vh",
        position: "absolute",
        zIndex: "999",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <img
        src={Loading}
        alt="Loading"
        style={{
          width: "50%",
          height: "auto",
        }}
        loading="lazy"
      />
    </div>
  );
};

export default LoadingAbout;
